<template>
  <div class="animated fadeIn" id="list-decomptes">
    <v-server-table id="table-decomptes_dc_inval" ref="decomptes_dc_inval_table" :columns="columns" :options="options" style="overflow: hidden;">
      <div v-if="props.row.created_at" slot="created_at" slot-scope="props" class="slot-date center-date">
        <span class="badge badge-success p-2">{{ formatDate(props.row.created_at) }}</span>
      </div>
      <div
        v-if="props.row.date_ed_decompte"
        slot="date_ed_decompte"
        slot-scope="props"
        class="slot-date center-date"
      >
        <span class="badge badge-success p-2">{{ formatDate(props.row.date_ed_decompte) }}</span>
      </div>
      <div v-if="props.row.date_em_pai" slot="date_em_pai" slot-scope="props" class="slot-date center-date">
        <span class="badge badge-success p-2">{{ formatDate(props.row.date_em_pai) }}</span>
      </div>
      <span
        v-if="props.row.nom_ben_rglt"
        slot="nom_ben_rglt"
        slot-scope="props"
      >{{ props.row.nom_ben_rglt }}</span>
      <span
        v-if="props.row.nom_dest_decompte"
        slot="nom_dest_decompte"
        slot-scope="props"
      >{{ props.row.nom_dest_decompte }}</span>
      <div slot="tot_payer" slot-scope="props" class="slot-number">
        <i>{{ getNatureDecompte(props.row.tot_payer)}}</i><br>
        <span v-if="props.row.tot_payer > 0"><b>+</b></span>
        <span v-if="props.row.tot_payer < 0" style="color:#ce0b35"><b>{{ formatNumber(props.row.tot_payer) }} €</b></span>
        <span v-else><b>{{ formatNumber(props.row.tot_payer) }} €</b></span>
      </div>
      <div
        v-if="props.row.id_pp_dest_reglement"
        slot="id_pp_dest_reglement"
        slot-scope="props"
        class="slot-number"
      >
        <span>{{ props.row.id_pp_dest_reglement }}</span>
      </div>
      <div v-if="props.row.num_decompte" slot="num_decompte" slot-scope="props" class="slot-number">
        <span>{{ props.row.num_decompte }}</span>
      </div>
      <div
        v-if="props.row.numero_contrat_col"
        slot="numero_contrat_col"
        slot-scope="props"
      >
        <span class="float-right">{{ props.row.numero_contrat_col }}</span><br><span class="family-prod">{{ props.row.produit }}</span>
      </div>
      <div v-if="props.row.lib_gar" slot="lib_gar" slot-scope="props">
        <span :class="'decompte-' + props.row.type_decompte">{{ props.row.lib_gar }}</span>
      </div>
      <div v-if="props.row.nom_ben_presta" slot="nom_ben_presta" slot-scope="props" class="formatted-box">
        <b>{{ props.row.nom_ben_presta }} {{ props.row.prenom_ben_presta }}</b> <br>
        <span style="color: #2139ff;">{{ props.row.nir_pp }}</span>
      </div>
      <div v-else slot="nom_ben_presta" slot-scope="props" class="formatted-box">
        <b>{{ props.row.nom_dest }} {{ props.row.prenom_dest }}</b> <br>
        <span style="color: #2139ff;">{{ props.row.nir_pp }}</span>
      </div>
      <span
        v-if="props.row.nom_dest"
        slot="nom_dest"
        slot-scope="props"
      >{{ props.row.nom_dest }} {{ props.row.prenom_dest }}</span>
      <!-- Pour la liste des décomptes après recherche -->

      <div v-if="(props.row.type_decompte == 'dc' && props.row.tot_payer < 0 || props.row.tot_payer == 0 )" slot="decomptePdf" slot-scope="props">
      </div>
      <div v-else class="wrapper" slot="decomptePdf" slot-scope="props" style="text-align:center">
        <img style="width: 15px;" class="mr-2 clickable" :src="getIcon('pdf')" @click="download(props.row)">
      </div>
    </v-server-table>
  </div>
</template>

<script>
  import { getProvider } from "@/utils/auth";
  import { formatDate, formatNumber } from "@/utils/communHelper";
  import { isEmpty, getFileIcon, downloadFile } from "@/utils/fileHelper";

  export default {
    name: "DecomptesDcInval",
    data() {
      let self = this;
      return {
        url: '',
        decomptes: [],
        indeterminate_1: false,
        selectedOption1: null,
        columns: [
          "created_at",
          "date_ed_decompte",
          "id_pp_dest_reglement",
          // "nir_pp",
          "num_decompte",
          "numero_contrat_col",
          "nom_ben_presta",
          "nom_dest",
          "rs_pm_site",
          "lib_gar",
          "date_em_pai",
          "tot_payer",
          "decomptePdf"
        ],
        items: [],
        searchData: [],
        excelData: [],
        options: {
          headings: {
            created_at: "Date de \nchargement",
            date_ed_decompte: "Date \nd'édition",
            id_pp_dest_reglement: "N° Ident. NSI",
            // nir_pp: "N° Sécu. Soc.",
            num_decompte: "N°Décompte",
            numero_contrat_col: "N° Contrat \nFamille prod.",
            nom_ben_presta: "Bénéficiaire \nNIR",
            nom_dest: "Destinataire",
            rs_pm_site: "Etablissement",
            lib_gar: "Type de rente",
            date_em_pai: "Date de \npaiement",
            tot_payer: "Nature \nMontant",
            decomptePdf: "#"
          },
          columnsClasses: {
            nom_ben_presta: 'pre-formatted sort-top position-r',
            tot_payer: 'pre-formatted sort-top position-r text-right',
            id_pp_dest_reglement: 'pre-formatted sort-top position-r text-right',
            num_decompte: 'pre-formatted sort-top position-r text-right',
            numero_contrat_col: 'pre-formatted sort-top position-r',
            decomptePdf: 'pre-formatted sort-top text-center position-r',
            created_at: 'pre-formatted sort-top text-center position-r',
            date_ed_decompte: 'pre-formatted sort-top text-center position-r',
            date_em_pai: 'pre-formatted sort-top text-center position-r',
          },
          perPage: 10,
          perPageValues: [10, 25, 50],
          sortable: [],
          filterable: false,
          requestFunction: function (data) {
            self.url = '/espaceGestion/dossier/getDecomptesDossier/' + self.dossier.id;
            return axios.get(self.url, {
              params: data
            })
            .then(function(response){
              // self.$store.commit('IS_LOADING', false);
              self.$event.emit('stopLoadingDecompte');
              return response;
            })
            .catch(function (e) {
              console.log(e);
              // self.$store.commit('IS_LOADING', false);
              self.$event.emit('stopLoadingDecompte');
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
                showConfirmButton: false,
                timer: 5000
              });
            }.bind(this));
          }
        },
        formatDate,
        formatNumber,
        isEmpty,
      };
    },
    props: ['dossier', 'allStatus'],
    mounted() {
      this.$event.on('refreshDecomptes', () => {
        this.$refs.decomptes_dc_inval_table.refresh();
      });
    },
    methods: {
      onLoaded(){
        this.$store.commit("IS_LOADING", false);
      },
      getNatureDecompte(montant) {
        let nature = 'Pour info';
        if (montant > 0) {
          nature = 'Versement';
        } else if (montant < 0) {
          nature = 'Débit restant';
        }
        return nature;
      },
      formatNir(textNir) {
        if(textNir !== null  && textNir !== ''){

          let nirs = textNir.split(',');
          let displayNir = '';

          nirs.forEach(function (element){
            if(element.length > 13){
              if(displayNir === ''){
                displayNir = element.substring(0,13);
              }else{
                displayNir = displayNir + '\n' + element.substring(0,13);
              }
            }
          });
          return displayNir;
        }else{
          return textNir;
        }
      },
      getIcon(extension) {
        let images = require.context('../../../assets/images/', false, /^\.\/\S+.*\.[a-zA-Z]+$/);
        let extensionIcon = getFileIcon();
        return images('./' + extensionIcon[extension]);
      },
      download(decompte){
        console.log('decompte',decompte)
        this.downloadPDF(decompte.num_decompte, decompte.id, decompte.id_pp_dest_reglement, decompte.type_decompte);
      },
      downloadPDF(numDecompte, decompte_id, idpp, typeDecompte) {
        let self = this;

        let dataPost = {};
        dataPost.idpp = idpp;
        dataPost.typeRente = typeDecompte;
        dataPost.provider = getProvider();
        
        this.$store.commit('IS_LOADING', true);
        this.$axios.post('/espaceBeneficiaire/beneficiaires/decomptes/download/' + decompte_id, dataPost, {responseType: 'arraybuffer'})
          .then((response) => {
            this.$store.commit('IS_LOADING', false);
            downloadFile(response, 'decompte_' + numDecompte, 'pdf');
          })
          .catch(function (error) {
            self.$store.commit('IS_LOADING', false);
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
    }
  };
</script>
<style>
  .formatted-box {
    white-space: nowrap !important;
    max-width: 100% !important;
  }
  tr.VueTables__row td {
    line-height: 25px;
    padding: 0 0.75rem;
  }

  .IZ-select__input input {
    font-size: 0.9rem;
  }

  .hasError {
    border-radius: 5px;
  }

  .bg-white {
    background-color: #FFFFFF;
  }

  .tooltip.b-tooltip.pre-formatted .tooltip-inner {
    white-space: pre-line;
    max-width: 100% !important;
  }

  .tooltip.b-tooltip.pre-formatted {
    max-width: 100%;
  }

  tr td.tooltip-cell {
    padding: 0;
  }

  tr td.tooltip-cell > div span {
    display: inline-block;
    width: 100%;
    padding: 0 0 0 0.75rem;
  }

  .ul-tooltip {
    padding: 0;
    list-style: none;
  }

  .green {
    color: #28a745;
  }

  .VueTables__sort-icon {
    float: none;
    position: absolute;
    right: 0.25rem;
  }

  .sort-top .VueTables__sort-icon {
    top: 0.75rem;
  }

  .sort-bottom .VueTables__sort-icon {
    bottom: 0.75rem;
  }

  .sort-middle .VueTables__sort-icon {
    bottom: 40%;
  }

  .min-width-nir {
    min-width: 175px;
  }

  .btn-disable {
    cursor: not-allowed;
    pointer-events: none;
    color: #c0c0c0;
    background-color: #ffffff;
  }

  #list-decomptes .wrapper {
    text-align: center;
}

#list-decomptes .VueTables__table thead tr th:first-child {
  width: 8%;
}
#list-decomptes .VueTables__table thead tr th:nth-child(2) {
  width: 6%;
}
#list-decomptes .VueTables__table thead tr th:nth-child(3) {
  width: 6%;
}
#list-decomptes .VueTables__table thead tr th:nth-child(4) {
  width: 6%;
}
#list-decomptes .VueTables__table thead tr th:nth-child(5) {
  width: 8%;
}
#list-decomptes .VueTables__table thead tr th:nth-child(6) {
  width: 8%;
}
#list-decomptes .VueTables__table thead tr th:nth-child(7) {
  width: 10%;
}
#list-decomptes .VueTables__table thead tr th:nth-child(8) {
  width: 10%;
}
#list-decomptes .VueTables__table thead tr th:nth-child(9) {
  width: 6%;
}
#list-decomptes .VueTables__table thead tr th:nth-child(10) {
  width: 6%;
}
#list-decomptes .VueTables__table thead tr th:nth-child(11) {
  width: 7%;
}
#list-decomptes .VueTables__table thead tr th:nth-child(12) {
  width: 5%;
}

.center-date {
  margin-top: 10px;
}
</style>
